module.exports = __webpack_public_path__ + "static/media/zcdt_Right@2x.498ea671.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zcdt_Right@2x.png
// module id = 1883
// module chunks = 0 1